import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './OrderConfirmationPage.css';

const PaymentFailedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const paymentState = location.state?.paymentState === 'incomplete' ? 'incomplete' : 'failed';
  const title = paymentState === 'incomplete' ? 'Payment Not Completed' : 'Payment Failed';
  const message = location.state?.message || (
    paymentState === 'incomplete'
      ? 'Your payment was not completed. Please proceed again. Your cart is still saved.'
      : 'Your payment could not be processed. Please try again. Your cart is still saved.'
  );
  const buttonLabel = paymentState === 'incomplete' ? 'Proceed Again' : 'Try Again';

  return (
    <div className="checkout-container">
      <div className="error-message" style={{textAlign:'center',padding:'40px 20px'}}>
        <h2 style={{color:'#dc3545',fontSize:'2rem'}}>{title}</h2>
        <p style={{margin:'20px 0',fontSize:'1.2rem'}}>{message}</p>
        <button 
          className="back-button"
          style={{marginTop:20,fontSize:'1.1rem',padding:'12px 32px'}}
          onClick={() => navigate('/checkout')}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default PaymentFailedPage; 
